import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Summary, ReviewCard } from '../pages/ReviewsPage';
import { useCustomerAuth } from '../context/CustomerAuthContext';

const HomeReviews = () => {
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const { isAuthed, headers } = useCustomerAuth();
  const [hasMine, setHasMine] = useState(false);
  useEffect(() => {
    if (!isAuthed) { setHasMine(false); return; }
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/reviews/mine`, { headers }).then(({ data: d }) => setHasMine(!!d)).catch(() => {});
  }, [isAuthed, headers]);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/reviews`).then(({ data: d }) => setData(d)).catch(() => {});
  }, []);
  if (!data) return null;
  const top = data.reviews.slice(0, 6);

  return (
    <section data-testid="home-reviews" className="max-w-7xl mx-auto px-6 pt-6 pb-20">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <div className="text-[11px] tracking-[0.3em] uppercase text-brand font-semibold">Reviews</div>
          <h2 className="mt-1 font-serif text-[28px] sm:text-[34px] leading-tight text-neutral-900 dark:text-neutral-100">What our customers say</h2>
        </div>
        {data.summary.count > 0 && (
          <Link to="/reviews" data-testid="home-reviews-see-all" className="group inline-flex items-center gap-1 text-[12.5px] text-brand font-medium whitespace-nowrap">
            See all reviews <ArrowRight size={13} className="transition-transform group-hover:translate-x-0.5" />
          </Link>
        )}
      </div>
      <Summary s={data.summary} onWrite={() => navigate('/reviews?write=1')} hasMine={hasMine} />
      {top.length > 0
        ? <div data-testid="home-reviews-list" className="mt-5 grid gap-4 md:grid-cols-2 lg:grid-cols-3">{top.map((r, i) => <ReviewCard key={r.id} r={r} i={i} />)}</div>
        : <p data-testid="home-reviews-empty" className="mt-6 text-center text-[14px] text-neutral-500">No reviews yet — be the first to share your experience.</p>}
    </section>
  );
};

export default HomeReviews;
